/* eslint-disable no-unused-vars */
let currentTranslations = null;
let currentLanguage = null;

module.exports.setLocaleData = function setLocaleData({
  language,
  translations
}) {
  currentLanguage = language || null;
  currentTranslations = translations || null;
};

module.exports._ = function _(text, values) {
  let translatedText = text;

  if (
    currentTranslations &&
    Object.prototype.hasOwnProperty.call(currentTranslations, text)
  ) {
    translatedText = currentTranslations[text];
  }

  // Check if the data is null, undefined or empty object
  if (!values || Object.keys(values).length === 0) {
    return translatedText;
  }

  const template = `${translatedText}`;
  return template.replace(/\${(.*?)}/g, (match, key) =>
    values[key.trim()] !== undefined ? values[key.trim()] : match
  );
};
